import Default from './Default';
import Login from './Login';

export interface Props {
    children: React.ReactElement|Array<React.ReactElement>|null,
}

export default Default;
export const LayoutLogin = Login;
